// extracted by mini-css-extract-plugin
module.exports = {"root":"_b6d5e0f5","title":"_5477d98c","link":"_134da43e","imageContainer":"_4ed47278","image":"_b9d51b27","badge":"_82d2a606","date":"_5066bccb"};